import { createReducer, on } from "@ngrx/store";
import { InstructionActions } from "../actions";
import {
  ConfirmedInstruction,
  Instruction,
  OpenInstruction,
} from "src/app/models/instruction/instruction";
import { InstructionConfirmation } from "src/app/models/instruction/instruction-confirmation";

export interface InstructionState {
  confirmedInstructions: ConfirmedInstruction[];
  openInstructions: OpenInstruction[];
  isLoading: boolean;
}

const initialState = {
  confirmedInstructions: [],
  openInstructions: [],
  isLoading: false,
} as InstructionState;

export const instructionReducer = createReducer(
  initialState,

  on(InstructionActions.loadInstructions, (state, _) => ({
    ...state,
    isLoading: true,
    openInstructions: [],
    confirmedInstructions: [],
  })),
  on(InstructionActions.loadedInstructions, (state, action) => ({
    ...state,
    isLoading: false,
    openInstructions: action.open,
    confirmedInstructions: action.confirmed,
  })),
);
